export const RatingIcon = () => <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.41667 1L8.09042 4.29127L11.8333 4.82229L9.125 7.38275L9.76417 11L6.41667 9.29127L3.06917 11L3.70833 7.38275L1 4.82229L4.74292 4.29127L6.41667 1Z" stroke="white" strokeWidth="1.38914" strokeLinecap="round" strokeLinejoin="round" />
</svg>
